// extracted by mini-css-extract-plugin
export default {"bodyFooter":"Footer_bodyFooter__N9YtJ","icons":"Footer_icons__ejNfK","copyright":"Footer_copyright__ZQCpa"};